import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {LoadingService} from '@/app/core/services/loading.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (isLoading) {
      <div
        class="loader-overlay"
        role="status"
        aria-live="polite"
        aria-label="Loading">
        <div class="loader-content">
          <div class="loader-icon-wrapper">
            <svg class="loader-arrows" viewBox="0 0 80 80" aria-hidden="true">
              <defs>
                <linearGradient
                  id="loaderGradient"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="100%">
                  <stop offset="0%" style="stop-color: var(--color-primary)" />
                  <stop
                    offset="100%"
                    style="stop-color: var(--color-secondary)" />
                </linearGradient>
              </defs>
              <!-- Two rounded arrows chasing each other -->
              <path
                class="arrow arrow-1"
                d="M 40 14 A 26 26 0 0 1 66 40 A 26 26 0 0 1 40 66"
                fill="none"
                stroke="url(#loaderGradient)"
                stroke-width="3"
                stroke-linecap="round" />
              <path
                class="arrow arrow-2"
                d="M 40 66 A 26 26 0 0 1 14 40 A 26 26 0 0 1 40 14"
                fill="none"
                stroke="url(#loaderGradient)"
                stroke-width="3"
                stroke-linecap="round" />
            </svg>
            <img
              src="/logo/icon.svg"
              alt=""
              class="loader-icon"
              width="48"
              height="48" />
          </div>
        </div>
      </div>
    }
  `,
  styleUrls: ['./loader.scss'],
})
export class LoaderComponent implements OnInit {
  private readonly loadingService = inject(LoadingService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);

  protected isLoading = false;

  ngOnInit(): void {
    this.loadingService.isLoading$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((loading) => {
        this.isLoading = loading;
        this.cdr.markForCheck();
      });
  }
}
